import { api } from "./useApi";
import {FormSchemaType, StepOneType} from "../schemas/formSchema";
import {Plan, Ticket} from "../types/Plans";

export const CompanyApi = () => ({
    sendLeads: async (
        data: StepOneType,
        plan: Plan,
        ticket: Ticket | null,
        trackingParams?: {
            utm_content: string | null;
            utm_medium: string | null;
            utm_campaign: string | null;
            utm_source: string | null;
            utm_term: string | null;
            utm_referrer: string | null;
            referrer: string | null;
            gclientid: string | null;
            gclid: string | null;
            fbclid: string | null;
        }
    ) => {
        // Calculate discounted value
        let planoValor = plan?.valor || 0;
        if (ticket && plan?.valor) {
            if (ticket.tipo_desconto === 'percentual') {
                planoValor = plan.valor - (plan.valor * ticket.desconto) / 100;
            } else {
                planoValor = plan.valor - ticket.desconto;
            }
        }

        // Round to 2 decimal places
        planoValor = Math.round(planoValor * 100) / 100;

        let response = await api.post("/contrate/enviar_leads", {
            'cf-turnstile-response': data.captchaStepOne,
            nome: data.fullName,
            email: data.email,
            telefone: data.phone,
            id_plano: plan?.id_superlogica ? plan.id_superlogica : null,
            cupom: ticket?.nome || null,
            plano_valor: planoValor,
            produto_comprado: `Plano ${plan?.nome} | ${plan?.periodicidade}`,
            ...(trackingParams && {
                utm_content: trackingParams.utm_content,
                utm_medium: trackingParams.utm_medium,
                utm_campaign: trackingParams.utm_campaign,
                utm_source: trackingParams.utm_source,
                utm_term: trackingParams.utm_term,
                utm_referrer: trackingParams.utm_referrer,
                referrer: trackingParams.referrer,
                gclientid: trackingParams.gclientid,
                gclid: trackingParams.gclid,
                fbclid: trackingParams.fbclid,
            }),
        });
        return response.data;
    },
    createCompany: async (data: FormSchemaType, plan: Plan, ticket: Ticket | null) => {
        const pagamentos: Record<string, string> = {
            credit_card: "cartao",
            pix: "pix",
            billet: "boleto",
        }

        // Calculate discounted value
        let planoValor = plan.valor;
        if (ticket) {
            if (ticket.tipo_desconto === 'percentual') {
                planoValor = plan.valor - (plan.valor * ticket.desconto) / 100;
            } else {
                planoValor = plan.valor - ticket.desconto;
            }
        }
        
        // Round to 2 decimal places
        planoValor = Math.round(planoValor * 100) / 100;

        // Reativação (?reativa=1): sinaliza o back p/ pular o trial (cobra no dia seguinte).
        // O valor cheio + REATIVA40 já são resolvidos no back pelo cupom atrelado.
        const reativacao = new URLSearchParams(window.location.search).get('reativa') === '1';

        let requestData: any = {
            'cf-turnstile-response': data.captchaStepTwo,
            nome: data.fullName,
            email: data.email,
            senha: data.password,
            telefone: data.phone,
            cpf_cnpj: data.cpfCnpj,
            codigo_sms: data.codigoSms,
            metodo_pagamento: pagamentos[data.paymentMethod],
            plano_id: plan.id_superlogica,
            plano_nome: plan.nome,
            plano_periodicidade: plan.periodicidade,
            plano_valor: planoValor,
            plano_valor_cheio: plan.valor,
            produto_comprado: `Plano ${plan.nome} | ${plan.periodicidade}`,
            reativacao: reativacao,
        }

        if(data.paymentMethod === "credit_card") {
            requestData = {
                ...requestData,
                cartao_numero: data.cardNumber,
                cartao_nome: data.cardHolderName,
                cartao_validade: data.expirationDate,
                cartao_cvv: data.cvv,
                cartao_parcelas: data.installments,
                cpf_responsavel: data.cpfResponsavel || null,
            }
        }

        if(ticket){
            requestData = {
                ...requestData,
                cupom: ticket.nome,
            }
        }

        let response = await api.post("/contrate/cadastrar_empresa", requestData);
        return response.data;
    },
    reenviarCodigoSms: async (data: { nome: string; telefone: string }) => {
        let response = await api.post("/contrate/reenviar_codigo_sms", {
            nome: data.nome,
            telefone: data.telefone,
        });
        return response.data;
    }
});